import React, { useState, useEffect } from 'react';

const CooldownButton = ({ onClick, label }) => {
    const cooldowns = [120, 30, 60, 120, 240]; // Cooldowns per attempt (sec)
    const [attempt, setAttempt] = useState(0);
    const [timer, setTimer] = useState(cooldowns[0]);

    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const handleClick = () => {
        if (timer > 0 || attempt >= cooldowns.length) return;

        onClick(); // Perform your actual logic

        const nextAttempt = attempt + 1;
        setAttempt(nextAttempt);
        setTimer(cooldowns[nextAttempt] || 0); // Use 0 if cooldowns end
    };

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m > 0 ? `${m}m ` : ''}${s}s`;
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button
                className="link-btn"
                onClick={handleClick}
                disabled={timer > 0 || attempt >= cooldowns.length}
                style={{
                    background: 'none',
                    border: 'none',
                    color: timer > 0 ? 'gray' : 'rgba(206, 77, 156, 0.62)',
                    cursor: timer > 0 || attempt >= cooldowns.length ? 'not-allowed' : 'pointer',
                    textDecoration: 'underline'
                }}
            >
                {label}
            </button>
            {timer > 0 && (
                <span style={{ fontSize: '14px', color: '#999' }}>
                    ({formatTime(timer)})
                </span>
            )}
        </div>
    );
};

export default CooldownButton;
